import React from 'react';
import './App.css'; // Ensure the CSS file is correctly imported
import MintComponent from './components/MintComponent';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="App-title">Welcome Wizard</h1>
        <h2 className="App-subtitle">Mint Bunny Bats</h2> {/* Add your subtitle here */}
        <MintComponent />
      </header>
    </div>
  );
}

export default App;